
import axios from '../../helpers/axios';


export const updatedColorProduct = (id, updateColorProduct) => axios.patch(`/colorProduct/update/${id}`, updateColorProduct)
export const deletedColorProduct = (id) => axios.delete(`/colorProduct/delete/${id}`)
